import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "@phosphor-icons/react";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  // Auto-scroll in cima ad ogni cambio di rotta.
  // Salta se l'URL contiene un hash (#sezione) così l'ancora funziona.
  useEffect(() => {
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      data-testid="scroll-to-top"
      onClick={scrollUp}
      aria-label="Torna su"
      className={`fixed bottom-6 right-6 z-40 w-12 h-12 bg-[#1A1918] hover:bg-[#EB0D0D] text-[#FAF9F6] flex items-center justify-center rounded-sm shadow-lg transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <ArrowUp size={20} weight="bold" />
    </button>
  );
}
